export class Category {

	public _id: string
	public category_id: string
	public name: string
	public media_url: any
}
